const ssn = {
    ssn : {
        value: "",
        dbqName: "form1[0].#subform[0].SSN[0]"
     },
     examDate: {
        value: "",
        dbqName: "form1[0].#subform[0].TextField6[11]"
    },
     docName: {
         value: "",
         dbqName: "form1[0].#subform[13].SectionXII-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "form1[0].#subform[13].SectionXII-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "form1[0].#subform[13].SectionXII-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "form1[0].#subform[13].SectionXII-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "form1[0].#subform[13].SectionXII-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "form1[0].#subform[13].SectionXII-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "form1[0].#subform[13].SectionXII-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[0].CheckBox36[0]",
            sides: {
                right: "form1[0].#subform[0].#area[0].CheckBox36[1]",
                left: "form1[0].#subform[0].#area[0].CheckBox36[2]",
                both: "form1[0].#subform[0].#area[0].CheckBox36[3]",
                rightDateDbqName: "form1[0].#subform[0].#area[0].TextField6[0]",
                leftDateDbqName: "form1[0].#subform[0].#area[0].TextField6[1]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[1].CheckBox36[4]",
            sides: {
                right: "form1[0].#subform[0].#area[1].CheckBox36[5]",
                left: "form1[0].#subform[0].#area[1].CheckBox36[6]",
                both: "form1[0].#subform[0].#area[1].CheckBox36[7]",
                rightDateDbqName: "form1[0].#subform[0].#area[1].TextField6[2]",
                leftDateDbqName: "form1[0].#subform[0].#area[1].TextField6[3]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[2].CheckBox36[8]",
            sides: {
                right: "form1[0].#subform[0].#area[2].CheckBox36[9]",
                left: "form1[0].#subform[0].#area[2].CheckBox36[10]",
                both: "form1[0].#subform[0].#area[2].CheckBox36[11]",
                rightDateDbqName: "form1[0].#subform[0].#area[2].TextField6[4]",
                leftDateDbqName: "form1[0].#subform[0].#area[2].TextField6[5]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[3].CheckBox36[12]",
            sides: {
                right: "form1[0].#subform[0].#area[3].CheckBox36[13]",
                left: "form1[0].#subform[0].#area[3].CheckBox36[14]",
                both: "form1[0].#subform[0].#area[3].CheckBox36[15]",
                rightDateDbqName: "form1[0].#subform[0].#area[3].TextField6[6]",
                leftDateDbqName: "form1[0].#subform[0].#area[3].TextField6[7]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[4].CheckBox36[16]",
            sides: {
                right: "form1[0].#subform[0].#area[4].CheckBox36[17]",
                left: "form1[0].#subform[0].#area[4].CheckBox36[18]",
                both: "form1[0].#subform[0].#area[4].CheckBox36[19]",
                rightDateDbqName: "form1[0].#subform[0].#area[4].TextField6[9]",
                leftDateDbqName: "form1[0].#subform[0].#area[4].TextField6[10]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[31].CheckBox36[130]",
            sides: {
                right: "form1[0].#subform[1].#area[31].CheckBox36[131]",
                left: "form1[0].#subform[1].#area[31].CheckBox36[132]",
                both: "form1[0].#subform[1].#area[31].CheckBox36[133]",
                rightDateDbqName: "form1[0].#subform[1].#area[31].TextField6[80]",
                leftDateDbqName: "form1[0].#subform[1].#area[31].TextField6[81]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[26].CheckBox36[114]",
            sides: {
                right: "form1[0].#subform[1].#area[26].CheckBox36[115]",
                left: "form1[0].#subform[1].#area[26].CheckBox36[116]",
                both: "form1[0].#subform[1].#area[26].CheckBox36[117]",
                rightDateDbqName: "form1[0].#subform[1].#area[26].TextField6[70]",
                leftDateDbqName: "form1[0].#subform[1].#area[26].TextField6[71]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[5].CheckBox36[23]",
            sides: {
                right: "form1[0].#subform[1].#area[5].CheckBox36[24]",
                left: "form1[0].#subform[1].#area[5].CheckBox36[25]",
                both: "form1[0].#subform[1].#area[5].CheckBox36[26]",
                rightDateDbqName: "form1[0].#subform[1].#area[5].TextField6[17]",
                leftDateDbqName: "form1[0].#subform[1].#area[5].TextField6[18]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[6].CheckBox36[27]",
            sides: {
                right: "form1[0].#subform[1].#area[6].CheckBox36[28]",
                left: "form1[0].#subform[1].#area[6].CheckBox36[29]",
                both: "form1[0].#subform[1].#area[6].CheckBox36[30]",
                rightDateDbqName: "form1[0].#subform[1].#area[6].TextField6[19]",
                leftDateDbqName: "form1[0].#subform[1].#area[6].TextField6[20]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[25].CheckBox36[110]",
            sides: {
                right: "form1[0].#subform[1].#area[25].CheckBox36[111]",
                left: "form1[0].#subform[1].#area[25].CheckBox36[112]",
                both: "form1[0].#subform[1].#area[25].CheckBox36[113]",
                rightDateDbqName: "form1[0].#subform[1].#area[25].TextField6[66]",
                leftDateDbqName: "form1[0].#subform[1].#area[25].TextField6[67]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[10].CheckBox36[43]",
            sides: {
                right: "form1[0].#subform[1].#area[10].CheckBox36[44]",
                left: "form1[0].#subform[1].#area[10].CheckBox36[45]",
                both: "form1[0].#subform[1].#area[10].CheckBox36[46]",
                rightDateDbqName: "form1[0].#subform[1].#area[10].TextField6[27]",
                leftDateDbqName: "form1[0].#subform[1].#area[10].TextField6[28]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[11].CheckBox36[47]",
            sides: {
                right: "form1[0].#subform[1].#area[11].CheckBox36[48]",
                left: "form1[0].#subform[1].#area[11].CheckBox36[49]",
                both: "form1[0].#subform[1].#area[11].CheckBox36[50]",
                rightDateDbqName: "form1[0].#subform[1].#area[11].TextField6[29]",
                leftDateDbqName: "form1[0].#subform[1].#area[11].TextField6[30]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[12].CheckBox36[51]",
            sides: {
                right: "form1[0].#subform[1].#area[12].CheckBox36[52]",
                left: "form1[0].#subform[1].#area[12].CheckBox36[53]",
                both: "form1[0].#subform[1].#area[12].CheckBox36[54]",
                rightDateDbqName: "form1[0].#subform[1].#area[12].TextField6[31]",
                leftDateDbqName: "form1[0].#subform[1].#area[12].TextField6[32]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[13].CheckBox36[55]",
            sides: {
                right: "form1[0].#subform[1].#area[13].CheckBox36[56]",
                left: "form1[0].#subform[1].#area[13].CheckBox36[57]",
                both: "form1[0].#subform[1].#area[13].CheckBox36[58]",
                rightDateDbqName: "form1[0].#subform[1].#area[13].TextField6[33]",
                leftDateDbqName: "form1[0].#subform[1].#area[13].TextField6[34]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[14].CheckBox36[59]",
            sides: {
                right: "form1[0].#subform[1].#area[14].CheckBox36[60]",
                left: "form1[0].#subform[1].#area[14].CheckBox36[61]",
                both: "form1[0].#subform[1].#area[14].CheckBox36[62]",
                rightDateDbqName: "form1[0].#subform[1].#area[14].TextField6[35]",
                leftDateDbqName: "form1[0].#subform[1].#area[14].TextField6[36]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[15].CheckBox36[63]",
            sides: {
                right: "form1[0].#subform[1].#area[15].CheckBox36[64]",
                left: "form1[0].#subform[1].#area[15].CheckBox36[65]",
                both: "form1[0].#subform[1].#area[15].CheckBox36[66]",
                rightDateDbqName: "form1[0].#subform[1].#area[15].TextField6[37]",
                leftDateDbqName: "form1[0].#subform[1].#area[15].TextField6[38]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[16].CheckBox36[67]",
            sides: {
                right: "form1[0].#subform[1].#area[16].CheckBox36[68]",
                left: "form1[0].#subform[1].#area[16].CheckBox36[69]",
                both: "form1[0].#subform[1].#area[16].CheckBox36[70]",
                rightDateDbqName: "form1[0].#subform[1].#area[16].TextField6[39]",
                leftDateDbqName: "form1[0].#subform[1].#area[16].TextField6[40]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[17].CheckBox36[71]",
            sides: {
                right: "form1[0].#subform[1].#area[17].CheckBox36[72]",
                left: "form1[0].#subform[1].#area[17].CheckBox36[73]",
                both: "form1[0].#subform[1].#area[17].CheckBox36[74]",
                rightDateDbqName: "form1[0].#subform[1].#area[17].TextField6[41]",
                leftDateDbqName: "form1[0].#subform[1].#area[17].TextField6[42]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[18].CheckBox36[75]",
            sides: {
                right: "form1[0].#subform[1].#area[18].CheckBox36[76]",
                left: "form1[0].#subform[1].#area[18].CheckBox36[77]",
                both: "form1[0].#subform[1].#area[18].CheckBox36[78]",
                rightDateDbqName: "form1[0].#subform[1].#area[18].TextField6[43]",
                leftDateDbqName: "form1[0].#subform[1].#area[18].TextField6[44]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[7].CheckBox36[31]",
            sides: {
                right: "form1[0].#subform[1].#area[7].CheckBox36[32]",
                left: "form1[0].#subform[1].#area[7].CheckBox36[33]",
                both: "form1[0].#subform[1].#area[7].CheckBox36[34]",
                rightDateDbqName: "form1[0].#subform[1].#area[7].TextField6[21]",
                leftDateDbqName: "form1[0].#subform[1].#area[7].TextField6[22]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[8].CheckBox36[35]",
            sides: {
                right: "form1[0].#subform[1].#area[8].CheckBox36[36]",
                left: "form1[0].#subform[1].#area[8].CheckBox36[37]",
                both: "form1[0].#subform[1].#area[8].CheckBox36[38]",
                rightDateDbqName: "form1[0].#subform[1].#area[8].TextField6[23]",
                leftDateDbqName: "form1[0].#subform[1].#area[8].TextField6[24]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[9].CheckBox36[39]",
            sides: {
                right: "form1[0].#subform[1].#area[9].CheckBox36[40]",
                left: "form1[0].#subform[1].#area[9].CheckBox36[41]",
                both: "form1[0].#subform[1].#area[9].CheckBox36[42]",
                rightDateDbqName: "form1[0].#subform[1].#area[9].TextField6[25]",
                leftDateDbqName: "form1[0].#subform[1].#area[9].TextField6[26]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[19].CheckBox36[79]",
            sides: {
                right: "form1[0].#subform[1].#area[19].CheckBox36[80]",
                left: "form1[0].#subform[1].#area[19].CheckBox36[81]",
                both: "form1[0].#subform[1].#area[19].CheckBox36[82]",
                rightDateDbqName: "form1[0].#subform[1].#area[19].TextField6[46]",
                leftDateDbqName: "form1[0].#subform[1].#area[19].TextField6[47]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[20].CheckBox36[83]",
            sides: {
                right: "form1[0].#subform[1].#area[20].CheckBox36[84]",
                left: "form1[0].#subform[1].#area[20].CheckBox36[85]",
                both: "form1[0].#subform[1].#area[20].CheckBox36[86]",
                rightDateDbqName: "form1[0].#subform[1].#area[20].TextField6[48]",
                leftDateDbqName: "form1[0].#subform[1].#area[20].TextField6[49]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[21].CheckBox36[87]",
            sides: {
                right: "form1[0].#subform[1].#area[21].CheckBox36[88]",
                left: "form1[0].#subform[1].#area[21].CheckBox36[89]",
                both: "form1[0].#subform[1].#area[21].CheckBox36[90]",
                rightDateDbqName: "form1[0].#subform[1].#area[21].TextField6[50]",
                leftDateDbqName: "form1[0].#subform[1].#area[21].TextField6[51]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[22].CheckBox36[91]",
            sides: {
                right: "form1[0].#subform[1].#area[22].CheckBox36[92]",
                left: "form1[0].#subform[1].#area[22].CheckBox36[93]",
                both: "form1[0].#subform[1].#area[22].CheckBox36[94]",
                rightDateDbqName: "form1[0].#subform[1].#area[22].TextField6[52]",
                leftDateDbqName: "form1[0].#subform[1].#area[22].TextField6[53]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[23].CheckBox36[95]",
            sides: {
                right: "form1[0].#subform[1].#area[23].CheckBox36[96]",
                left: "form1[0].#subform[1].#area[23].CheckBox36[97]",
                both: "form1[0].#subform[1].#area[23].CheckBox36[98]",
                rightDateDbqName: "form1[0].#subform[1].#area[23].TextField6[54]",
                leftDateDbqName: "form1[0].#subform[1].#area[23].TextField6[55]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].CheckBox36[134]",
            sides: {
                right: "form1[0].#subform[1].#area[27].CheckBox36[118]",
                left: "form1[0].#subform[1].#area[27].CheckBox36[119]",
                both: "form1[0].#subform[1].#area[27].CheckBox36[120]",
                rightDateDbqName: "form1[0].#subform[1].#area[27].TextField6[72]",
                leftDateDbqName: "form1[0].#subform[1].#area[27].TextField6[73]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].CheckBox36[135]",
            sides: {
                right: "form1[0].#subform[1].#area[30].CheckBox36[127]",
                left: "form1[0].#subform[1].#area[30].CheckBox36[128]",
                both: "form1[0].#subform[1].#area[30].CheckBox36[129]",
                rightDateDbqName: "form1[0].#subform[1].#area[30].TextField6[78]",
                leftDateDbqName: "form1[0].#subform[1].#area[30].TextField6[79]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].CheckBox36[137]",
            sides: {
                right: "form1[0].#subform[1].#area[29].CheckBox36[124]",
                left: "form1[0].#subform[1].#area[29].CheckBox36[125]",
                both: "form1[0].#subform[1].#area[29].CheckBox36[126]",
                rightDateDbqName: "form1[0].#subform[1].#area[29].TextField6[76]",
                leftDateDbqName: "form1[0].#subform[1].#area[29].TextField6[77]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].CheckBox36[136]",
            sides: {
                right: "form1[0].#subform[1].#area[28].CheckBox36[121]",
                left: "form1[0].#subform[1].#area[28].CheckBox36[122]",
                both: "form1[0].#subform[1].#area[28].CheckBox36[123]",
                rightDateDbqName: "form1[0].#subform[1].#area[28].TextField6[74]",
                leftDateDbqName: "form1[0].#subform[1].#area[28].TextField6[75]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[24].CheckBox36[99]",
            sides: {
                right: "form1[0].#subform[1].#area[24].CheckBox36[100]",
                left: "form1[0].#subform[1].#area[24].CheckBox36[101]",
                both: "form1[0].#subform[1].#area[24].CheckBox36[102]",
                rightDateDbqName: "form1[0].#subform[1].#area[24].TextField6[56]",
                leftDateDbqName: "form1[0].#subform[1].#area[24].TextField6[57]"
            },
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[1].TextField6[59]",
            sides: {
                right: "form1[0].#subform[1].CheckBox36[104]",
                left: "form1[0].#subform[1].CheckBox36[105]",
                both: "form1[0].#subform[1].CheckBox36[106]",
                rightDateDbqName: "form1[0].#subform[1].TextField6[60]",
                leftDateDbqName: "form1[0].#subform[1].TextField6[61]"
            },
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[1].TextField6[62]",
            sides: {
                right: "form1[0].#subform[1].CheckBox36[107]",
                left: "form1[0].#subform[1].CheckBox36[108]",
                both: "form1[0].#subform[1].CheckBox36[109]",
                rightDateDbqName: "form1[0].#subform[1].TextField6[63]",
                leftDateDbqName: "form1[0].#subform[1].TextField6[64]"
            },
        }   
    ]
}

export default ssn ;